<template>
  <k-page class="page-users">
    <div class="page-users__controls">
      <el-tooltip content="Обновить данные" placement="top">
        <el-button @click="update" type="primary" icon="el-icon-refresh-left" circle size="mini" :loading="isUsersLoading"></el-button>
      </el-tooltip>
    </div>


    <!-- BEGIN: Pagination -->
    <el-pagination
      v-if="numberOfPages > 1"
      @current-change="setCurrentPage"
      class="the-utils-emails__pagination"
      background
      layout="prev, pager, next"
      :total="usersCount"
      small
    >
    </el-pagination>
    <!-- END: Pagination -->

    <k-users-list
      :users="users"
      @edit="setUser"
      @delete="deleteUser"
      @updateImage="updateImage"
      @challenges="userChallenges"
    />

    <!-- BEGIN: Pagination -->
    <el-pagination
      v-if="numberOfPages > 1"
      @current-change="setCurrentPage"
      class="the-utils-emails__pagination"
      background
      layout="prev, pager, next"
      :total="usersCount"
      small
    >
    </el-pagination>
    <!-- END: Pagination -->
    <k-user-edit-form
      :dialogFormVisible="activeUser !== ''"
      :user="user"
      @cancel="handleCancel"
    />

    <k-user-image-form
      :dialogFormVisible="imageUpload !== ''"
      :user="user"
      :imageUpload="imageUpload"
      @cancel="handleCancel"
    />

    <k-user-challenges-list
      :dialogFormVisible="userChallenge !== ''"
      :user="user"
      :userChallenge="userChallenge"
      :challenges="challenges"
      @cancel="handleCancel"
      @updateChallenge="updateChallenge"
    />

    <k-challenge-update-form
      :dialogFormVisible="updateChallengeForm"
      :challenge="challenge"
      @cancel="handleCancelForm"
      @updateChallenge="updateChallenge"
    />
  </k-page>
</template>

<script>
/**
 * Page: Страница фондов
 *
 * @version 1.0.0
 */


import { mapGetters, mapActions } from 'vuex';


// Components
import KPage from '@/components/KPage.vue';
import KUserEditForm from '@/components/KUserEditForm.vue';
import KUserImageForm from '@/components/KUserImageForm.vue';
import KUserChallengesList from '@/components/KUserChallengesList.vue';
import KUsersList from '@/components/KUsersList.vue';
import KChallengeUpdateForm from '@/components/KChallengeUpdateForm.vue';


const NUMBER_OF_USERS_PER_PAGE = 10;


export default {
  name: 'page-users',

  data() {
    return {
      activeUser: '',
      imageUpload: '',
      userChallenge: '',
      challenge: {},
      updateChallengeForm: false,
      currentPage: 0,
    };
  },

  computed: {
    // Общее количество страниц с e-mail
    numberOfPages() {
      return Math.ceil(this.usersCount / NUMBER_OF_USERS_PER_PAGE);
    },

    user() {
      // eslint-disable-next-line
      const user = this.users.find(item => item._id === this.activeUser || item._id === this.imageUpload);
      return !user
        ? {}
        : user;
    },

    ...mapGetters({
      isUsersLoading: 'users/isUsersLoading',
      users: 'users/users',
      usersCount: 'users/usersCount',
      challenges: 'challenges/challenges',
    }),
  },

  async created() {
    await this.update();
  },

  methods: {
    async update() {
      await this.getUsers({
        limit: NUMBER_OF_USERS_PER_PAGE,
        offset: this.currentPage,
      });
    },

    setUser(id) {
      this.activeUser = id;
    },

    updateImage(id) {
      this.imageUpload = id;
    },

    async userChallenges(id) {
      this.userChallenge = id;
      await this.getChallenges({ limit: 100, offset: 0, userId: id });
    },

    async handleCancel() {
      this.activeUser = '';
      this.imageUpload = '';
      this.userChallenge = '';
      await this.getUsers({
        limit: NUMBER_OF_USERS_PER_PAGE,
        offset: this.currentPage,
      });
    },

    async deleteUser(id) {
      await this.deleteUsers(id);
      await this.update();
    },

    async setCurrentPage(numberOfPage) {
      this.currentPage = numberOfPage - 1;
      await this.update();
    },

    // Ивент для редактирование челленджа
    updateChallenge(challenge) {
      this.challenge = challenge;
      this.updateChallengeForm = true;
    },

    // Отмена редактирование челленджа
    handleCancelForm() {
      this.challenge = {};
      this.updateChallengeForm = false;
    },

    ...mapActions({
      deleteUsers: 'users/deleteUsers',
      getUsers: 'users/getUsers',
      getChallenges: 'challenges/getChallenges',
    }),
  },

  components: {
    KPage,
    KUserEditForm,
    KUsersList,
    KUserImageForm,
    KUserChallengesList,
    KChallengeUpdateForm,
  },
};
</script>

<style lang="scss">
  .page-users {
    display: flex;
    flex-direction: column;

    &__controls {
      margin-bottom: 24px;
    }
  }
</style>
